/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef } from 'react';
import Header from './Component/Header';
import './App.css';
import './index.css';
import './Style/style.css';
import './Style/Responsive.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer } from 'react-toastify';
import Footer from './Component/Footer';
import { Routes, Route, useLocation } from 'react-router-dom';
import { MyContext } from './Context/MyProvider';
import EventDetails from './Component/UserComponent/EventDetails';
import Dashboard from './Component/UserComponent/Dashboard';
import EventCategory from './Component/UserComponent/EventCategory';
import OrderSummery from './Component/UserComponent/OrderSummery';
import Booking from './Component/UserComponent/Booking';
import Ticket from './Component/UserComponent/Ticket';
import Favorite from './Component/UserComponent/Favorite';
import Wallet from './Component/UserComponent/Wallet';
import Success, { Cancel } from './Component/Payment/Success';
import PaymentResponse from './Component/Payment/PaymentResponse';
import Profile from './Component/UserComponent/Profile';
// import Chat from './Component/UserComponent/Chat';
import Faq from './Component/Faq';
import Pages from './Component/Pages';
import Organizer from './Component/UserComponent/Organizer';
import UserForm from './Component/UserComponent/UserForm';
import PaymentStatus from './Component/UserComponent/PaymentStatus';
import FormList from './Component/UserComponent/FormList';
import BusinessUser from './Component/UserComponent/BusinessUser';
import Events from './Component/UserComponent/Events';
import Offers from './Component/UserComponent/Offers';
import { syncAuthFromShop } from './utils/auth';
import DynamicEventDetailPage from './Component/UserComponent/DynamicEventDetailPage';

function App() {

  const location = useLocation();
  const { setIsLogin, setIsShowBtn } = useContext(MyContext);
  const hasCheckedShopAuth = useRef(false);
  const Hidden = location.pathname.startsWith("/chat") || location.pathname.startsWith("/payment-status");

  useEffect(() => {
    const isHomePage = location.pathname === "/";

    if (!isHomePage && hasCheckedShopAuth.current) return;

    hasCheckedShopAuth.current = true;
    syncAuthFromShop({ setIsLogin, setIsShowBtn });
  }, [location.pathname, setIsLogin, setIsShowBtn]);

  useEffect(() => {
    const handlePageShow = (event) => {
      if (!event.persisted || window.location.pathname !== "/") return;

      syncAuthFromShop({ setIsLogin, setIsShowBtn });
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [setIsLogin, setIsShowBtn]);

  return (
    <>
      {!Hidden && <Header />}
      <Routes>

        <Route path="/" element={<Dashboard />} />
        <Route path="/events" element={<Events />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/business-user" element={<BusinessUser />} />
        <Route path="/event-details" element={<EventDetails />} />
        {/* <Route path="/event-details/:id" element={<EventDetails />} /> */}
        <Route path="/event-details/:slug" element={<EventDetails />} />
        <Route path="/event-category" element={<EventCategory />} />
        <Route path="/order-summery" element={<OrderSummery />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/e-ticket" element={<Ticket />} />
        <Route path="/favorite" element={<Favorite />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/done" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/PaymentRespons" element={<PaymentResponse />} />
        <Route path="/profile" element={<Profile />} />
        {/* <Route path="/chat" element={<Chat />} /> */}
        <Route path="/faq" element={<Faq />} />
        <Route path=":title" element={<Pages />} />
        <Route path="/organizer-info" element={<Organizer />} />
        <Route path="/form/:slug" element={<UserForm />} />
        <Route path="/form-list" element={<FormList />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/payment-status/:razorpay_order_id" element={<PaymentStatus />} />
        <Route path="/event-page-dynamic/:slug" element={<DynamicEventDetailPage />} />

      </Routes>

      {!Hidden && <Footer />}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
/* jshint ignore:end */
